import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-88c7f268"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: "https://s.moimg.net/activity/images/mainField.png"
}, null, -1));
const _hoisted_2 = {
  key: 0,
  class: "mainTips"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mainTipsImg",
  src: "https://p6.moimg.net/mdwxapp/download-guide-icon.png"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "点击右上角选择浏览器打开", -1));
const _hoisted_5 = [_hoisted_3, _hoisted_4];
import { env } from "md-base-tools/env";
// import { onMounted } from "vue";
import { getAppDownloadUrl } from "@/api/index";
import { useRoute } from "vue-router";
export default {
  setup(__props) {
    const route = useRoute();

    // onMounted(() => {
    //     if (!env.isWeixin()) {
    //         goDownload()
    //     }
    // })
    const goDownload = async () => {
      let link = '';
      if (env.isIos()) {
        //ios
        link = 'https://itunes.apple.com/cn/app/mo-dian-zhong-chou-you-xi/id995178524?l=en&mt=8';
        //link = 'https://testflight.apple.com/join/sCAwkevh';  // 临时地址
      } else {
        // 安卓
        const res = await getAppDownloadUrl({
          app_channel: route.query.app_channel || 'default'
        });
        if (res.status == 0 && res.data && res.data.download_url) {
          link = res.data.download_url;
        } else {
          // link = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.modian.app';
          link = 'https://apk.modian.com/ModianApp-lastest-release-modian.apk'; // 临时地址
        }
      }
      if (link) {
        window.location.href = link;
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "download-box",
        onClick: goDownload
      }, [_hoisted_1, _unref(env).isWeixin() ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5)) : _createCommentVNode("", true)]);
    };
  }
};